import * as React from "react";
import OpInputNumField from "../generic/opInputNumField";
import indexer from "./../../../types/genericTypes";
import "../../../../assets/scss/components/toc/orderPlacement/sample/opSampleComponents.scss";
import { floatNumExp } from "../../../utils/regex";
import InputField from "../../../generic/inputField";
import OpTotalPeriod from "../generic/opTotalPeriod";

export interface IOpSampleValidationsProps {}

const OpSampleValidations: React.FC<IOpSampleValidationsProps> = () => {
	const [inputErrors, setInputErrors] = React.useState<indexer>({});

	function onInputChange(val: string) {
		console.log(val);
	}

	function onInputBlur(key: string, error?: indexer) {
		console.log(error);
		setInputErrors({ ...inputErrors, [key]: error });
	}

	function showError(index: string, validationText?: indexer) {
		// if error is not there, then return
		if (!inputErrors[index]) {
			return null;
		}

		// otherwise return error message
		if (inputErrors[index].required) {
			return "Input is required";
		}
		if (inputErrors[index].min) {
			return "Input should be greater than equal to " + validationText!.min;
		}
		if (inputErrors[index].max) {
			return "Input should be less than equal to " + validationText!.max;
		}
		if (inputErrors[index].multiple) {
			return "Input should be multiple of " + validationText!.multiple;
		}
	}

	return (
		<div className="op_sample_components">
			<h2 className="sample_heading">Required + numeric:</h2>
			<OpInputNumField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("first", error)}
				placeholder="Enter Amount"
				prefix="prefix"
				errorText={showError("first")}
				required
			/>

			<br />
			<br />

			<h2 className="sample_heading">Integer:</h2>
			<OpInputNumField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("second", error)}
				placeholder="Enter Amount"
				suffix="suffix"
				integer
			/>

			<br />
			<br />

			<h2 className="sample_heading">Float (two decimals):</h2>
			<OpInputNumField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("third", error)}
				placeholder="Enter Amount"
				prefix="prefix"
				suffix="suffix"
				float={floatNumExp()}
			/>

			<br />
			<br />

			<h2 className="sample_heading">Alpha numeric</h2>
			<InputField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("fourth", error)}
				placeholder="Enter Amount"
				alphanum
			/>

			<br />
			<br />

			<h2 className="sample_heading">Minimum</h2>
			<InputField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("fifth", error)}
				placeholder="Enter Amount"
				min={2}
				suffix="Min: 2"
				errorText={showError("fifth", { min: "2" })}
			/>

			<br />
			<br />

			<h2 className="sample_heading">Maximum</h2>
			<InputField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("sixth", error)}
				placeholder="Enter Amount"
				max={20}
				suffix="Max: 20"
				errorText={showError("sixth", { max: "20" })}
			/>

			<br />
			<br />

			<h2 className="sample_heading">Multiple</h2>
			<OpInputNumField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("seventh", error)}
				placeholder="Enter Amount"
				multiple={4}
				helpText="Enter multiple of 4 only"
				errorText={showError("seventh", { multiple: "4" })}
			/>

			<br />
			<br />

			<h2 className="sample_heading">Multiple with max validation</h2>
			<OpInputNumField
				onChange={val => onInputChange(val)}
				onBlur={error => onInputBlur("eighth", error)}
				placeholder="Enter Amount"
				multiple={5}
				max={40}
				suffix="Max: 40"
				helpText="Enter multiple of 5 only"
				errorText={showError("eighth", { max: "40", multiple: "4" })}
			/>

			<br />
			<br />

			<h2 className="sample_heading">Multiple with max validation (Total Period)</h2>
			<OpTotalPeriod
				label="Total Period"
				id="ninth"
				onChange={val => onInputChange(val.toString())}
				onBlur={error => onInputBlur("ninth", error)}
				multiple={5}
				max={40}
				helpTextGrey="Enter multiple of 5 only"
				helpTextBlue="Max : 40"
				errorText={showError("ninth", { max: "40", multiple: "4" })}
			/>

			<br />
			<br />
		</div>
	);
};

export default OpSampleValidations;
